import { render, staticRenderFns } from "./DeleteComment.vue?vue&type=template&id=248ffc9a&scoped=true&"
import script from "./DeleteComment.vue?vue&type=script&lang=js&"
export * from "./DeleteComment.vue?vue&type=script&lang=js&"
import style0 from "./DeleteComment.vue?vue&type=style&index=0&id=248ffc9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ffc9a",
  null
  
)

export default component.exports